module.exports = {
  // Style prefix
  stylePrefix: 'mo-chat-',
  right: 0,
  bottom: 20,
  width: null,
  height: null,
  flagGreeting: false,
  flagMidLate: true,
  width: 420,
  height: 100,
  dataMessError: [],
  dataLoaded: false,
  dataMess: {
    data: []
  },
  domain_id: '',
  //dev1
  // domain: 'http://localhost:8080/dist/',
  // test1
  // domain: 'https://test40.mobio.vn/landing-pages/chat-tool/',
  // domain: 'https://test20.mobio.vn/landing-pages/chat-tool/',
  // domainAPI: 'https://chungnt.mobio.vn/chattool/api/v1.0',
  // domainSocket: 'https://chungnt.mobio.vn/chat',
  // domainSocial: 'https://chungnt.mobio.vn/social/api/v1.0',
  // domainAPI: 'https://api-test1.mobio.vn/chattool/api/v1.0',
  // domainSocket: 'https://api-test1.mobio.vn/chat',
  // domainSocial: 'https://api-test1.mobio.vn/social/api/v1.0',

  domain: '#DOMAIN_API#/mo-lib/chatbox/',
  domainAPI: '#DOMAIN_API#/chattool/api/v1.0',
  domainSocket: '#DOMAIN_API#/chat',
  domainSocial: '#DOMAIN_API#/social/api/v1.0',

  emoji_smileys: [
    '128512',
    '128513',
    '128514',
    '128515',
    '128516',
    '128517',
    '128518',
    '128519',
    '128520',
    '128521',
    '128522',
    '128523',
    '128524',
    '128525',
    '128526',
    '128527',
    '128528',
    '128529',
    '128530',
    '128531',
    '128532',
    '128533',
    '128534',
    '128535',
    '128536',
    '128537',
    '128538',
    '128539',
    '128540',
    '128541',
    '128542',
    '128543',
    '128544',
    '128545',
    '128546',
    '128547',
    '128548',
    '128549',
    '128550',
    '128551',
    '128552',
    '128553',
    '128554',
    '128555',
    '128556',
    '128557',
    '128558',
    '128559'
  ]
};
